import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  headersTeds,
  headersTedsCustomTable,
  TedsTableRow,
  valoresExibidosOffCanvasTeds,
} from './auxiliarTeds';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import DetailsTable from '../../../../components/CustomTable/DetailsTable';
import CustomTableOffcanvas from '../../../../components/CustomTableOffcanvas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { getTedsByUsuario } from '../../../../services/teds/tedsService';
import theme from '../../../../theme';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
  formatarNumero,
  formatarValorFormatoDinheiro,
} from '../../../../utils/functions';
import { SubAbas as subAbas } from '../../ProcessosAquisitivos/subabas';

const TedsIndex: React.FC = () => {
  //DADOS USUARIO
  const user = getUser();
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const userComponenteAf = Number(user.vinculo[0].numeroComponenteAF);

  const navigate = useNavigate();
  //OPTIONS
  // const componenteAF = useComponentesPaf();
  const { getSelectDominioPai } = useSelect();
  const statusTedOptions = getSelectDominioPai(52);
  const componenteAFoptions = getSelectDominioPai(1);
  const fornecedorPapelOptions = getSelectDominioPai(58);

  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getTedsByUsuario();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // TABELA E OFFCANVAS
  const tableData = data.map((item) => ({
    id: item?.id ?? 'Não informado',

    status:
      statusTedOptions.find((status) => status.value === item.status)?.label ??
      'Não informado',
    componenteAf:
      componenteAFoptions.find(
        (componenteAf) => componenteAf.value === item.componenteAf,
      )?.label ?? 'Não informado',
    numeroTed: item.numeroTed ?? 'Não informado',
    fornecedor:
      '[' + item.fornecedor?.cnpj + '] - ' + item.fornecedor?.nomeFantasia,
  }));

  const offCanvasData = data.map((item) => {
    // Definindo cores de fundo com base no status do documento
    let statusBackgroundColor = '';
    let colorText = theme.colors.preto;

    const statusLabel = statusTedOptions.find(
      (option) => option.value === item.status,
    )?.label;

    if (statusLabel === 'Em Elaboração') {
      statusBackgroundColor = theme.colors.amarelogov;
      colorText = theme.colors.branco;
    } else if (statusLabel === 'Em Execução') {
      statusBackgroundColor = theme.colors.verde;
      colorText = theme.colors.branco;
    } else if (statusLabel === 'Encerrado') {
      statusBackgroundColor = theme.colors.cinzaEscuro;
      colorText = theme.colors.branco;
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = theme.colors.laranja;
      colorText = theme.colors.branco;
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = theme.colors.vermelho;
      colorText = theme.colors.branco;
    }

    const componenteSigla = componenteAFoptions
      .find((option) => option.value === item.componenteAf)
      ?.label.slice(0, 1)
      .toUpperCase();

    let componenteBackgroundColor = '';
    if (item.componenteAf === 2) {
      componenteBackgroundColor = theme.colors.azulgov;
    } else if (item.componenteAf === 3) {
      componenteBackgroundColor = theme.colors.amarelogov;
    } else if (item.componenteAf === 4) {
      componenteBackgroundColor = theme.colors.verdegov;
    }
    const valorTotalDosProdutos =
      item.produtos?.reduce(
        (acc: number, produto: any) => acc + (produto.valorTotal || 0),
        0,
      ) || 0;
    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      status: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            color: colorText,
            borderRadius: '10px',
            padding: '12px',
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {statusLabel}
        </span>
      ),
      componenteAf: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: componenteBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {componenteSigla}
          </span>
          <span style={{ marginLeft: '8px' }}>
            {
              componenteAFoptions.find(
                (option) => option.value === item.componenteAf,
              )?.label
            }
          </span>
        </div>
      ),
      nupSeiFase1: item.nupSeiFase1,
      nupSeiFase2: item.nupSeiFase2,
      numeroTed: item.numeroTed,
      dataInicio: formatDateSimp(item.dataInicio),
      dataTermino: formatDateSimp(item.dataTermino),
      separadorFornecedor: '',
      fornecedor:
        item.fornecedor.razaoSocial + ' (' + item.fornecedor.cnjp + ')',
      fornecedorPapel: fornecedorPapelOptions.find(
        (option) => option.value === item.fornecedorPapel,
      )?.label,
      produtos:
        item.produtos?.length > 0 ? (
          <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
            {item.produtos
              ?.sort((a: any, b: any) =>
                a.produtoDAF.localeCompare(b.produtoDAF),
              ) // Ordena os produtos
              .map((produto: any, index: number) => {
                return (
                  <li key={index} style={{ marginBottom: '5px' }}>
                    <b>{produto.produtoDAF}</b>
                    <br />
                    <span style={{ marginLeft: '0px' }}>
                      Quatidade: {formatarNumero(produto.qtdTotal)} | Valor: R${' '}
                      {formatarValorFormatoDinheiro(produto.valorTotal)}
                    </span>
                  </li>
                );
              })}
          </ul>
        ) : (
          <span style={{ fontStyle: 'italic', color: '#888' }}>
            Não informado
          </span>
        ),
      valorTotal: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          R$ {formatarValorFormatoDinheiro(valorTotalDosProdutos)}
        </div>
      ),
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar TEDs.',
        showConfirmButton: true,
      });
      return;
    }
    navigate('dadosgerais', { state: { userComponenteAf } });
  };

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);
  const offcanvasOpenRoute = useMemo(() => {
    if (!selectedDetailsRowId) return undefined;

    const baseHash = window.location.hash.replace(/\/$/, '');
    return `${baseHash}/${selectedDetailsRowId}/dadosgerais`;
  }, [selectedDetailsRowId]);

  const handleOpenDetails = (row: TedsTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const handleTableRowClick = (row: TedsTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersTedsCustomTable}
          data={tableData}
          displayValues={valoresExibidosOffCanvasTeds}
          offcanvasTitle="Detalhes do TED"
          widthOffcanvas="50%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          // emptyMessage="Carregando..."
          showPagination={true}
          showOpenButton={true}
          filterable={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidosOffCanvasTeds}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes inserir onClickInserir={handleClickInserir} />
      </BarraInferiorBotoes>
    </>
  );
};

export default TedsIndex;
